<section class="painel-filtros">
    <div class="cabecalho-painel">
        <i class="pi pi-filter"></i>
        <h2>Filtros</h2>
    </div>
    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('codigo')" [attr.aria-expanded]="!blocosColapsados.codigo">
            <h3>Código</h3>
            <i [class]="iconeColapso('codigo')"></i>
        </button>

        @if (!blocosColapsados.codigo) {
            <div class="conteudo-bloco">
                <label class="campo-unico">
                    Código da reunião
                    <input type="text" inputmode="numeric" [(ngModel)]="filtrosLocais.codigoReuniao" placeholder="Ex.: 5601" />
                </label>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('periodo')" [attr.aria-expanded]="!blocosColapsados.periodo">
            <h3>Período</h3>
            <i [class]="iconeColapso('periodo')"></i>
        </button>

        @if (!blocosColapsados.periodo) {
            <div class="conteudo-bloco">
                <div class="grupo-radio">
                    @for (opcao of opcoesPeriodo; track opcao.valor) {
                        <label class="opcao-radio">
                            <input type="radio" name="periodo" [value]="opcao.valor" [(ngModel)]="filtrosLocais.periodo" />
                            <span>{{ opcao.rotulo }}</span>
                        </label>
                    }
                </div>

                @if (filtrosLocais.periodo === 'por-periodo') {
                    <div class="campo-inline">
                        <label>
                            Início
                            <input type="date" [(ngModel)]="filtrosLocais.dataInicial" />
                        </label>
                        <label>
                            Fim
                            <input type="date" [(ngModel)]="filtrosLocais.dataFinal" />
                        </label>
                    </div>
                }
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('status')" [attr.aria-expanded]="!blocosColapsados.status">
            <h3>Status da reunião</h3>
            <i [class]="iconeColapso('status')"></i>
        </button>

        @if (!blocosColapsados.status) {
            <div class="conteudo-bloco">
                <div class="grupo-radio">
                    @for (opcao of opcoesStatus; track opcao.valor) {
                        <label class="opcao-radio">
                            <input type="radio" name="status" [value]="opcao.valor" [(ngModel)]="filtrosLocais.status" />
                            <span>{{ opcao.rotulo }}</span>
                        </label>
                    }
                </div>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('tipoComissao')" [attr.aria-expanded]="!blocosColapsados.tipoComissao">
            <h3>Tipo de comissão</h3>
            <i [class]="iconeColapso('tipoComissao')"></i>
        </button>

        @if (!blocosColapsados.tipoComissao) {
            <div class="conteudo-bloco">
                <div class="grupo-radio">
                    @for (opcao of opcoesTipoComissao; track opcao.valor) {
                        <label class="opcao-radio">
                            <input type="radio" name="tipo-comissao" [value]="opcao.valor" [(ngModel)]="filtrosLocais.tipoComissao" />
                            <span>{{ opcao.rotulo }}</span>
                        </label>
                    }
                </div>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('comissaoGrupo')" [attr.aria-expanded]="!blocosColapsados.comissaoGrupo">
            <h3>Comissão/Câmara Técnica/Grupo de Trabalho</h3>
            <i [class]="iconeColapso('comissaoGrupo')"></i>
        </button>

        @if (!blocosColapsados.comissaoGrupo) {
            <div class="conteudo-bloco">
                <label class="campo-unico">
                    Selecionar
                    <div class="campo-busca-linha">
                        <input type="text" [value]="descricaoEstruturaSelecionada()" placeholder="Nenhuma estrutura selecionada" readonly />
                        <button type="button" class="botao-icone" (click)="buscarComissaoGrupo()" title="Buscar">
                            <i class="pi pi-search"></i>
                        </button>
                        <button type="button" class="botao-icone limpar" (click)="limparComissaoGrupo()" title="Limpar">
                            <i class="pi pi-ban"></i>
                        </button>
                    </div>
                </label>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('membroConvidado')" [attr.aria-expanded]="!blocosColapsados.membroConvidado">
            <h3>Membro / Convidado Presente</h3>
            <i [class]="iconeColapso('membroConvidado')"></i>
        </button>

        @if (!blocosColapsados.membroConvidado) {
            <div class="conteudo-bloco">
                <label class="campo-unico">
                    Selecionar
                    <div class="campo-busca-linha">
                        <input type="text" [(ngModel)]="filtrosLocais.membroConvidado" placeholder="Digite o nome" />
                        <button type="button" class="botao-icone" (click)="buscarMembroConvidado()" title="Buscar">
                            <i class="pi pi-search"></i>
                        </button>
                        <button type="button" class="botao-icone limpar" (click)="limparMembroConvidado()" title="Limpar">
                            <i class="pi pi-ban"></i>
                        </button>
                    </div>
                </label>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('assistente')" [attr.aria-expanded]="!blocosColapsados.assistente">
            <h3>Assistente</h3>
            <i [class]="iconeColapso('assistente')"></i>
        </button>

        @if (!blocosColapsados.assistente) {
            <div class="conteudo-bloco">
                <label class="campo-unico">
                    Nome
                    <select [(ngModel)]="filtrosLocais.assistente">
                        @for (opcao of opcoesAssistentes(); track opcao.valor) {
                            <option [value]="opcao.valor">{{ opcao.rotulo }}</option>
                        }
                    </select>
                </label>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('statusAta')" [attr.aria-expanded]="!blocosColapsados.statusAta">
            <h3>Status da Ata</h3>
            <i [class]="iconeColapso('statusAta')"></i>
        </button>

        @if (!blocosColapsados.statusAta) {
            <div class="conteudo-bloco">
                <label class="campo-unico">
                    Status
                    <select [(ngModel)]="filtrosLocais.statusAta">
                        @for (opcao of opcoesStatusAta(); track opcao.valor) {
                            <option [value]="opcao.valor">{{ opcao.rotulo }}</option>
                        }
                    </select>
                </label>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('local')" [attr.aria-expanded]="!blocosColapsados.local">
            <h3>Local da reunião</h3>
            <i [class]="iconeColapso('local')"></i>
        </button>

        @if (!blocosColapsados.local) {
            <div class="conteudo-bloco">
                <label class="campo-unico">
                    <select [(ngModel)]="filtrosLocais.local">
                        @for (opcao of opcoesLocais(); track opcao.valor) {
                            <option [value]="opcao.valor">{{ opcao.rotulo }}</option>
                        }
                    </select>
                </label>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('convocacoes')" [attr.aria-expanded]="!blocosColapsados.convocacoes">
            <h3>Convocações</h3>
            <i [class]="iconeColapso('convocacoes')"></i>
        </button>

        @if (!blocosColapsados.convocacoes) {
            <div class="conteudo-bloco">
                <div class="grupo-radio">
                    @for (opcao of opcoesConvocacoes; track opcao.valor) {
                        <label class="opcao-radio">
                            <input type="radio" name="convocacoes" [value]="opcao.valor" [(ngModel)]="filtrosLocais.convocacoes" />
                            <span>{{ opcao.rotulo }}</span>
                        </label>
                    }
                </div>
            </div>
        }
    </article>

    <article class="bloco-filtro">
        <button type="button" class="cabecalho-bloco" (click)="alternarColapso('atas')" [attr.aria-expanded]="!blocosColapsados.atas">
            <h3>Atas</h3>
            <i [class]="iconeColapso('atas')"></i>
        </button>

        @if (!blocosColapsados.atas) {
            <div class="conteudo-bloco">
                <div>
                    <span class="rotulo-subsecao">Importante</span>
                    <div class="grupo-radio">
                        @for (opcao of opcoesAtas; track opcao.valor) {
                            <label class="opcao-radio">
                                <input type="radio" name="atas" [value]="opcao.valor" [(ngModel)]="filtrosLocais.atas" />
                                <span>{{ opcao.rotulo }}</span>
                            </label>
                        }
                    </div>
                </div>
            </div>
        }
    </article>

    <div class="acoes-filtro">
        <button type="button" pButton [label]="labelBotaoColapso()" severity="secondary" [outlined]="true" (click)="colapsarFiltros()"></button>
        <button type="button" pButton label="Limpar filtros" severity="secondary" [outlined]="true" (click)="limpar()"></button>
        <button type="button" pButton label="Aplicar filtros" (click)="aplicar()"></button>
    </div>

    <p-dialog
        appDialogoPadrao="pi pi-check-square"
        descricao="Escolha um item para continuar."
        closeAriaLabel="Fechar"
        [(visible)]="exibirDialogComissaoGrupo"
        header="Seleção"
        [style]="{ width: '52rem', maxWidth: '96vw' }"
        [breakpoints]="{ '960px': '94vw', '640px': '98vw' }"
        (onHide)="cancelarSelecaoComissaoGrupo()"
    >
        <section class="dialog-estrutura-comissao">
            <div class="painel-arvore">
                @if (erroEstruturasComissao()) {
                    <div class="alerta-erro-dialog">{{ erroEstruturasComissao() }}</div>
                }

                @if (carregandoEstruturasComissao()) {
                    <div class="status-dialog">Carregando estruturas...</div>
                } @else {
                    <ng-container *ngTemplateOutlet="renderTiposComissao; context: { $implicit: nosTipoComissaoExibicao() }"></ng-container>
                }
            </div>

            <div class="filtros-dialog">
                <fieldset>
                    <legend>Tipo de Filtro</legend>
                    <label class="opcao-inline">
                        <input type="radio" name="tipo-filtro-estrutura" value="nome" [(ngModel)]="tipoFiltroEstrutura" />
                        Nome
                    </label>
                    <label class="opcao-inline">
                        <input type="radio" name="tipo-filtro-estrutura" value="codigo" [(ngModel)]="tipoFiltroEstrutura" />
                        Código
                    </label>
                </fieldset>

                <fieldset>
                    <legend>Filtro</legend>
                    <input type="text" [ngModel]="valorFiltroEstrutura" (ngModelChange)="onValorFiltroEstruturaChange($event)" />
                </fieldset>

                <fieldset>
                    <legend>Status da Comissão</legend>
                    <label class="opcao-inline">
                        <input type="radio" name="status-filtro-estrutura" value="todos" [(ngModel)]="statusFiltroEstrutura" />
                        Todos
                    </label>
                    <label class="opcao-inline">
                        <input type="radio" name="status-filtro-estrutura" value="ativas" [(ngModel)]="statusFiltroEstrutura" />
                        Ativas
                    </label>
                    <label class="opcao-inline">
                        <input type="radio" name="status-filtro-estrutura" value="extintas" [(ngModel)]="statusFiltroEstrutura" />
                        Extintas
                    </label>
                </fieldset>
            </div>
        </section>

        <ng-template pTemplate="footer">
            <div class="rodape-dialog-comissao">
                <span class="legenda-extinta"><i></i> Comissões Extintas</span>
                <div class="acoes-dialog">
                    <button type="button" pButton label="OK" (click)="confirmarSelecaoComissaoGrupo()" [disabled]="!noEstruturaSelecionado"></button>
                    <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="cancelarSelecaoComissaoGrupo()"></button>
                </div>
            </div>
        </ng-template>
    </p-dialog>

    <ng-template #renderTiposComissao let-tipos>
        <ul class="arvore-tipos">
            @for (tipo of tipos; track trackTipoComissao($index, tipo)) {
                <li>
                    <div class="linha-tipo-estrutura">
                        @if (tipo.filhos.length > 0) {
                            <button type="button" class="toggle-no" (click)="alternarExpandidoTipo(tipo.idTipoComissaoCt)">
                                <i [class]="tipoExpandido(tipo.idTipoComissaoCt) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                            </button>
                        } @else {
                            <span class="toggle-no vazio"></span>
                        }

                        <span class="rotulo-tipo-estrutura">{{ tipo.descricao }}</span>
                    </div>

                    @if (tipoExpandido(tipo.idTipoComissaoCt)) {
                        <ng-container *ngTemplateOutlet="renderNosEstrutura; context: { $implicit: tipo.filhos }"></ng-container>
                    }
                </li>
            } @empty {
                <li class="sem-registros-estrutura">Nenhum tipo de comissão encontrado.</li>
            }
        </ul>
    </ng-template>

    <ng-template #renderNosEstrutura let-nos>
        <ul class="arvore-estrutura">
            @for (no of nos; track trackNoEstrutura($index, no)) {
                <li>
                    <div class="linha-no-estrutura" [class.selecionado]="noEstruturaSelecionadoAtivo(no.id)">
                        @if (no.filhos.length > 0) {
                            <button type="button" class="toggle-no" (click)="alternarExpandidoEstrutura(no.id)">
                                <i [class]="noEstruturaExpandido(no.id) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                            </button>
                        } @else {
                            <span class="toggle-no vazio"></span>
                        }

                        <button type="button" class="rotulo-no" [class.extinta]="no.ativo !== 1" (click)="selecionarNoEstrutura(no)">{{ no.id }} - {{ no.descricao }}</button>
                    </div>

                    @if (no.filhos.length > 0 && noEstruturaExpandido(no.id)) {
                        <ng-container *ngTemplateOutlet="renderNosEstrutura; context: { $implicit: no.filhos }"></ng-container>
                    }
                </li>
            } @empty {
                <li class="sem-registros-estrutura">Nenhuma estrutura encontrada.</li>
            }
        </ul>
    </ng-template>
</section>
